/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatedAt
 */
export interface UpdatedAt {
}

/**
 * Check if a given object implements the UpdatedAt interface.
 */
export function instanceOfUpdatedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatedAtFromJSON(json: any): UpdatedAt {
    return UpdatedAtFromJSONTyped(json, false);
}

export function UpdatedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedAt {
    return json;
}

export function UpdatedAtToJSON(value?: UpdatedAt | null): any {
    return value;
}

